import type * as THREE from 'three';

// FORGIVING AIM (#5). Small world targets (a tiny dropped cube, a small chest, a furnace at a grazing angle) are hard
// to hit with a pixel-precise mesh raycast. `nearestOnRay` returns the candidate whose CENTRE the ray passes within
// `tol` metres of -- nearest along the ray, ahead of the origin -- so "pointing at it" is reliable without auto-nearest.
// Callers use it as a fallback AFTER a precise mesh hit (which still wins when it lands). LOS/reach are gated elsewhere.
export function nearestOnRay<T>(rc: THREE.Raycaster, items: ReadonlyArray<{ x: number; y: number; z: number; rec: T }>, tol: number): T | null {
  const o = rc.ray.origin, d = rc.ray.direction;
  let best: T | null = null, bestT = Infinity;
  for (const it of items) {
    const t = (it.x - o.x) * d.x + (it.y - o.y) * d.y + (it.z - o.z) * d.z; // distance along the ray to the candidate's closest point
    if (t <= 0) continue; // behind the camera/player
    const px = o.x + d.x * t, py = o.y + d.y * t, pz = o.z + d.z * t;
    if (Math.hypot(it.x - px, it.y - py, it.z - pz) <= tol && t < bestT) { bestT = t; best = it.rec; }
  }
  return best;
}
